const breakpoints = {
  tablet: 768,
  desktop: 1181,
  desktopLarge: 1651,
};

export default breakpoints;
